"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _links = require("self-service-api/core/utilities/links");

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _ImmutableTermIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableTermIdMap"));

var _ImmutableProductBasedOfferIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableProductBasedOfferIdMap"));

var _MerchandiseIdLists = require("self-service-api/constants/MerchandiseIdLists");

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _CheckoutPropsInterface = require("ui-addon-upgrades/_core/checkout/CheckoutPropsInterface");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _url = require("ui-addon-upgrades/_core/common/navigation/url");

var _generatePurchaseOrder = require("ui-addon-upgrades/_core/checkout/generatePurchaseOrder");

var _AdminOnlyWrapper = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/AdminOnlyWrapper"));

var _AdminTypes = require("ui-addon-upgrades/_core/common/constants/AdminTypes");

var _AdminModalTypes = require("ui-addon-upgrades/_core/common/constants/AdminModalTypes");

var CheckoutButton = function CheckoutButton(props) {
  var upgradeData = props.upgradeData,
      itemConfigurations = props.itemConfigurations,
      termId = props.termId,
      currencyCode = props.currencyCode,
      productBasedOffers = props.productBasedOffers,
      additionalUnitQuantity = props.additionalUnitQuantity,
      onClick = props.onClick,
      onError = props.onError,
      children = props.children,
      _props$beforeRedirect = props.beforeRedirect,
      beforeRedirect = _props$beforeRedirect === void 0 ? function () {
    return Promise.resolve(true);
  } : _props$beforeRedirect,
      rest = (0, _objectWithoutProperties2.default)(props, ["upgradeData", "itemConfigurations", "termId", "currencyCode", "productBasedOffers", "additionalUnitQuantity", "onClick", "onError", "children", "beforeRedirect"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      lastOrderGenerationFailed = _useState2[0],
      setLastOrderGenerationFailed = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isGeneratingPurchaseOrder = _useState4[0],
      setIsGeneratingPurchaseOrder = _useState4[1];

  var merchandiseIds = itemConfigurations.map(function (_ref) {
    var merchandiseId = _ref.merchandiseId;
    return merchandiseId;
  });

  var getCheckoutButtonInteractionTrackingProperties = function getCheckoutButtonInteractionTrackingProperties() {
    var merchandiseNames = merchandiseIds.map(function (merchId) {
      return _ImmutableMerchandiseIdMap.default[merchId].trackingName;
    });
    var productBasedOfferNames = productBasedOffers.map(function (offerId) {
      return _ImmutableProductBasedOfferIdMap.default[offerId].trackingName;
    });
    var isQuantityUpgrade = itemConfigurations.length === 1 && _MerchandiseIdLists.QUANTITY_MERCHANDISE_IDS.indexOf(itemConfigurations[0]) !== -1;
    var trackingProps = {
      additionalUnitQuantity: additionalUnitQuantity,
      currencyCode: currencyCode,
      merchandiseIds: merchandiseIds,
      merchandiseNames: merchandiseNames,
      productBasedOfferIds: productBasedOffers,
      productBasedOfferNames: productBasedOfferNames,
      isQuantityUpgrade: isQuantityUpgrade,
      termId: termId // TODO: Add quantity if quantity upgrade?

    };

    if (termId) {
      trackingProps = (0, _extends2.default)({}, trackingProps, {
        termId: termId,
        termName: _ImmutableTermIdMap.default[termId] ? _ImmutableTermIdMap.default[termId].trackingName : null
      });
    }

    return trackingProps;
  };

  (0, _react.useEffect)(function () {
    tracker.track('checkoutButtonInteraction', (0, _extends2.default)({
      action: 'viewed'
    }, upgradeData, getCheckoutButtonInteractionTrackingProperties())); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var onOrderGenerationStart = function onOrderGenerationStart(e) {
    setLastOrderGenerationFailed(false);
    setIsGeneratingPurchaseOrder(true);
    tracker.track('checkoutButtonInteraction', (0, _extends2.default)({
      action: 'clicked'
    }, upgradeData, getCheckoutButtonInteractionTrackingProperties()));

    if ((0, _utils.isFunction)(onClick)) {
      onClick(e);
    }
  };

  var onOrderGenerationComplete = function onOrderGenerationComplete() {
    setLastOrderGenerationFailed(false);
    setIsGeneratingPurchaseOrder(false);
    tracker.track('checkoutButtonInteraction', (0, _extends2.default)({
      action: 'purchase order generated'
    }, upgradeData, getCheckoutButtonInteractionTrackingProperties()));
  };

  var onOrderGenerationFailed = function onOrderGenerationFailed(err) {
    if ((0, _utils.isFunction)(onError)) {
      onError(err);
    }

    setLastOrderGenerationFailed(true);
    setIsGeneratingPurchaseOrder(false);
    tracker.track('checkoutButtonInteraction', (0, _extends2.default)({
      action: 'purchase order generation failed'
    }, upgradeData, getCheckoutButtonInteractionTrackingProperties()));
  };

  var handleClick = function handleClick(e) {
    onClick();
    onOrderGenerationStart(e);
    (0, _generatePurchaseOrder.generatePurchaseOrder)(termId, currencyCode, itemConfigurations, productBasedOffers).then(function (orderId) {
      onOrderGenerationComplete();
      var checkoutUrl = (0, _links.checkout)(orderId);
      beforeRedirect(checkoutUrl).then(function () {
        var shouldRedirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return shouldRedirect && (0, _url.navigateTo)(checkoutUrl);
      });
    }).catch(onOrderGenerationFailed);
  };

  var merchandiseId = (0, _utils.last)(merchandiseIds) || null;
  var propsToPass = (0, _utils.omit)(rest, ['allowModal']);
  return _react.default.createElement(_AdminOnlyWrapper.default, {
    adminType: _AdminTypes.BILLING,
    merchandiseId: merchandiseId,
    modalType: _AdminModalTypes.REQUEST_SKU
  }, _react.default.createElement(_UILoadingButton.default, (0, _extends2.default)({}, propsToPass, {
    failed: lastOrderGenerationFailed,
    loading: isGeneratingPurchaseOrder,
    onClick: handleClick,
    "data-selenium": "checkout-button",
    "data-reagan-primary-cta": true
  }), children || _react.default.createElement(_FormattedMessage.default, {
    message: 'upgrades.checkoutButton.default'
  })));
};

CheckoutButton.defaultProps = {
  use: 'primary',
  productBasedOffers: [],
  onClick: function onClick() {}
};
CheckoutButton.propTypes = (0, _extends2.default)({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, _CheckoutPropsInterface.CheckoutButtonPropsInterface);
var _default = CheckoutButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/checkout/CheckoutButton.js
// module id = 716
// module chunks = 5 6